import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getNationRivalry, getLivePulseSnapshot } from "@/lib/social.functions";
import { useLanguage } from "@/hooks/useLanguage";
import { Radio } from "lucide-react";

/** Live community moments: rotates phrases derived from real aggregates. */
export function CommunityMoments() {
  const { t } = useLanguage();
  const rivalry = useQuery({ queryKey: ["social", "nation_rivalry"], queryFn: () => getNationRivalry(), refetchInterval: 20_000 });
  const pulse = useQuery({ queryKey: ["social", "pulse_snap"], queryFn: () => getLivePulseSnapshot(), refetchInterval: 15_000 });

  const moments: string[] = [];
  const top = rivalry.data?.rows?.[0];
  if (top) moments.push(t("moment_nation_leads").replace("{nation}", String(top.nation_code)));
  if ((pulse.data?.hype_burst ?? 0) > 30) moments.push(t("moment_hype_explosion"));
  if ((pulse.data?.active_fans ?? 0) > 0) {
    moments.push(t("moment_active_fans").replace("{n}", String(pulse.data?.active_fans ?? 0)));
  }
  if (moments.length === 0) moments.push(t("moment_warming_up"));

  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setIdx((i) => (i + 1) % moments.length), 4500);
    return () => window.clearInterval(id);
  }, [moments.length]);

  return (
    <section className="flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-3 py-2">
      <Radio className="h-3.5 w-3.5 animate-pulse text-primary" />
      <span className="truncate text-xs font-bold">{moments[idx % moments.length]}</span>
    </section>
  );
}